import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { EmopPublicWorkflowCreateService } from './emop-public-workflow-create.service';
import { EmopPublicWorkflowCreateApiService } from './emop-public-workflow-create-api.service';
import { EmopPublicWorkflowCreateNewComponent } from './components/emop-public-workflow-create-new/emop-public-workflow-create-new.component';
import { EmopPublicWorkflowCreateAppointeeComponent } from './components/emop-public-workflow-create-appointee/emop-public-workflow-create-appointee.component';
import { NzNotificationService } from 'ng-zorro-antd/notification';

@Component({
  selector: 'emop-public-workflow-create',
  templateUrl: './emop-public-workflow-create.component.html',
  styleUrls: ['./emop-public-workflow-create.component.scss']
})
export class EmopPublicWorkflowCreateComponent implements OnInit {
  @Input() tenant: string = '';
  @Input() batchId: string = '';
  /**
   * 是否允许多选
   */
  @Input() multiple: boolean = true;
  /**
   * 是否允许删除默认用户
   */
  @Input() allowDeleteDefault: boolean = false;
  /**
   * 审批对象的表格
   */
  @Input() approvalTableHeader: {
    alias: string,
    key: string;
  }[] = [];

  @ViewChild('workflowCreateNew') workflowCreateNew: EmopPublicWorkflowCreateNewComponent;
  @ViewChild('workflowAppointee') workflowAppointee: EmopPublicWorkflowCreateAppointeeComponent;
  @Output() confirm = new EventEmitter;
  constructor(
    public EmopPublicWorkflowCreateService: EmopPublicWorkflowCreateService,
    private EmopPublicWorkflowCreateApiService: EmopPublicWorkflowCreateApiService,
    private NzNotificationService: NzNotificationService,
  ) { }

  /**
   * @param tenant
   * @param batchId 流程id
   */
  ngOnInit(): void {
    if (!this.tenant || !this.batchId) return console.error('请传入tenant和batchId');
    ['multiple', 'tenant', 'batchId', 'allowDeleteDefault'].forEach(item => {
      this.EmopPublicWorkflowCreateService.customParams[item] = this[item];
    });
    this.EmopPublicWorkflowCreateService.approvalTable.header = this.approvalTableHeader;
    this.EmopPublicWorkflowCreateService.clearData();
    this.getWorkflowTemplateList();
    this.getApprovalObject();
  }
  /**
   * 获取流程模板可选项
   */
  getWorkflowTemplateList() {
    this.EmopPublicWorkflowCreateApiService.processDefinitionsFilter(this.tenant, this.batchId).subscribe((rs) => {
      this.EmopPublicWorkflowCreateService.workflowTemplateList = rs.data;
    });
  }
  /**
   * 获取审批对象数据
   */
  getApprovalObject() {
    this.EmopPublicWorkflowCreateService.approvalTable.loading = true;
    this.EmopPublicWorkflowCreateApiService.startTaskPayload(this.tenant, this.batchId).subscribe((rs) => {
      this.EmopPublicWorkflowCreateService.approvalTable.data = rs.data;
      this.EmopPublicWorkflowCreateService.approvalTable.loading = false;
    });
  }
  /**
   * 发起流程
   */
  createWorkflow() {
    // 检查是否全填了任务指派
    if (this.EmopPublicWorkflowCreateService.appointeeList.some(item => !item.currentUser?.length)) {
      return this.NzNotificationService.error('指派任务检测出错', '请完整填写指派任务的人员分配');
    }

    let processAssignment = this.EmopPublicWorkflowCreateService.processAssignment;
    processAssignment.taskAssignments.forEach((item, index) => {
      item.candidates[0].assignees = this.EmopPublicWorkflowCreateService.appointeeList[index].currentUser;
    });
    const params = {
      tenant: this.EmopPublicWorkflowCreateService.customParams.tenant,
      batchId: this.EmopPublicWorkflowCreateService.customParams.batchId,
      remark: this.workflowCreateNew.remark,
      businessObjects: this.EmopPublicWorkflowCreateService.approvalTable.data,
      definitionId: this.workflowCreateNew.template.id,
      definitionKey: this.workflowCreateNew.template.key,
      processAssignment,
      workflowName: this.workflowCreateNew.workflowName,
      workflow_name: this.workflowCreateNew.template.name,
    };

    const newParams = { ...params, formData: { ...params } };

    this.EmopPublicWorkflowCreateApiService.createWorkflow(newParams).subscribe((rs) => {
      this.confirm.emit(rs);
    });
  }
}
